var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_371)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 50.4222C38.8072 50.4222 50 39.2294 50 25.4222C50 11.6151 38.8072 0.422241 25 0.422241C11.1929 0.422241 0 11.6151 0 25.4222C0 39.2294 11.1929 50.4222 25 50.4222ZM25 16.0472C22.4112 16.0472 20.3125 18.1459 20.3125 20.7347V22.2972H14.0625V20.7347C14.0625 14.6941 18.9594 9.79724 25 9.79724C31.0406 9.79724 35.9375 14.6941 35.9375 20.7347C35.9375 26.7754 31.0406 31.6722 25 31.6722H21.875V25.4222H25C27.5888 25.4222 29.6875 23.3236 29.6875 20.7347C29.6875 18.1459 27.5888 16.0472 25 16.0472ZM28.125 34.7972V41.0472H21.875V34.7972H28.125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.422241)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeQuestion);
export default __webpack_public_path__ + "static/media/home-question.252aaef4357f723064f8b073878c4257.svg";
export { ForwardRef as ReactComponent };